<template>
  <div class="brand-region-editor">
    <el-checkbox :value="value.allRegions" :disabled="disabled" @change="changeAllRegions">全国</el-checkbox>
    <p class="region-note">{{ value.allRegions ? '全国范围，包含后续新增地区。' : '可选择整省、整市或具体区县，支持多选。' }}</p>
    <template v-if="!value.allRegions">
      <el-cascader
        class="region-cascader"
        :value="paths"
        :options="regionOptions"
        :props="cascaderProps"
        :disabled="disabled"
        placeholder="搜索或选择省、市、区县"
        filterable
        clearable
        collapse-tags
        size="small"
        @change="changePaths"
      />
      <p class="region-note region-count">已选 {{ value.regions.length }} 个地区；选中省、市即包含全部下级地区。</p>
      <div v-if="value.regions.length" class="selected-regions">
        <el-tag v-for="region in value.regions" :key="region.codes.join('-')" size="small" type="info" :closable="!disabled" @close="removeRegion(region)">{{ region.names.join(' / ') }}{{ region.codes.length &lt; 3 ? '（全部）' : '' }}</el-tag>
      </div>
      <div v-else class="region-empty">请选择地区，或勾选「全国」</div>
    </template>
  </div>
</template>

<script>
import { regionData, codeToText } from "element-china-area-data";

export default {
  name: "BrandRegionEditor",
  props: {
    value: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { regionOptions: regionData, cascaderProps: { multiple: true, checkStrictly: true, emitPath: true } };
  },
  computed: {
    paths() { return this.value.regions.map(region => region.codes); },
  },
  methods: {
    changeAllRegions(allRegions) {
      this.$emit("input", { ...this.value, allRegions });
    },
    changePaths(paths) {
      const ordered = paths.map(path => path.map(String)).sort((first, second) => first.length - second.length || first.join("/").localeCompare(second.join("/")));
      const selected = [];
      ordered.forEach(path => {
        if (!selected.some(parent => parent.every((code, index) => path[index] === code))) selected.push(path);
      });
      this.$emit("input", { ...this.value, regions: selected.map(codes => ({ codes, names: codes.map(code => codeToText[code] || code) })) });
    },
    removeRegion(region) {
      this.$emit("input", { ...this.value, regions: this.value.regions.filter(item => item.codes.join("/") !== region.codes.join("/")) });
    },
  },
};
</script>

<style scoped>
.brand-region-editor { padding: 10px 12px; }
.region-note { margin: 4px 0 0; font-size: 12px; line-height: 20px; color: #73767a; }
.region-cascader { width: 100%; margin-top: 10px; }
.region-count { margin-top: 8px; }
.selected-regions { display: flex; flex-direction: column; align-items: flex-start; gap: 6px; margin-top: 8px; }
.selected-regions .el-tag { max-width: 100%; height: auto; white-space: normal; overflow-wrap: anywhere; }
.region-empty { padding: 16px 0; text-align: center; color: #73767a; font-size: 12px; }
</style>
